/**
 * @file Homepage.jsx
 * @description Componente de la página principal con sección hero e introducción al restaurante.
 */

import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Slider from '../components/Slider';
import InteractiveMenu from '../components/InteractiveMenu';
import Encuentranos from '../components/Encuentranos';
import Contactanos from '../components/Contactanos';

const Homepage = () => {
  return (
    <div>
      <Helmet>
        <title>DeliRous Restaurant | Gastronomía Peruana en Lima</title>
        <meta
          name="description"
          content="DeliRous Restaurant — Descubre los auténticos sabores de la gastronomía peruana en el corazón de Lima. Platillos tradicionales y fusiones innovadoras con ingredientes frescos."
        />
      </Helmet>

      {/* Sección Hero / Intro */}
      <Slider />


      {/* Sección Menú Interactivo */}
      <InteractiveMenu />

      {/* Sección Encuéntranos */}
      <Encuentranos />

      {/* Sección Contáctanos */}
      <Contactanos />

    </div>
  );
};

export default Homepage;

